export default __webpack_public_path__ + "static/media/LeldeLovelace.da51fbdb.png";